package app.bloomey.web.components.widgets

import androidx.compose.runtime.Composable
import app.bloomey.web.core.data.models.Video
import app.bloomey.web.core.res.Res
import app.bloomey.web.core.res.icPlayFilled
import app.bloomey.web.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.dom.disposableRef
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.ktor.util.*
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun VideoItem(item: Video, onClick: (Video) -> Unit) {
    val sitePalette = ColorMode.current.toSitePalette()
    Column(modifier = Modifier
        .cursor(Cursor.Pointer)
        .minWidth(100.percent)
        .maxWidth(100.percent)
        .overflow(Overflow.Clip)
        .onClick {
            onClick(item)
        }) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .minHeight(150.px)
                .aspectRatio(4 / 5),
            contentAlignment = Alignment.Center
        ) {
            Image(
                item.imageUrl.takeIf { it.startsWith("http") } ?: "",
                modifier = Modifier.fillMaxSize()
                    .objectFit(ObjectFit.Cover)
                    .borderRadius(10.px)
                    .margin(bottom = 8.px),
                ref = disposableRef {
                    if (!item.imageUrl.startsWith("http")) {
                        it.src = "data:image/png;base64, ${item.imageUrl.encodeToByteArray().encodeBase64()}".also {
                            println(it)
                        }
                    }

                    onDispose {

                    }
                }
            )
            SvgLoader(Res.Assets.icPlayFilled, color = Colors.White, modifier = Modifier.size(24.px))
        }
        SpanText(text = item.title, modifier = Modifier.margin(bottom = 4.px))
        SpanText(
            "${item.duration}",
            modifier = Modifier.color(sitePalette.onBackgroundLight).fontSize(14.px)
        )
    }
}